import styled from 'styled-components'
import { mdStyle, smStyle } from '@/components/Adapter'

export const PriceNewsStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const PriceNewsBoxDiv = styled.ul`
  list-style: none;
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;

  ${smStyle} {
    gap: 24px;
    grid-template-columns: 1fr 1fr 1fr;
  }
`

export const FundraisingNewsBoxDiv = styled.ul`
  list-style: none;
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;

  ${smStyle} {
    gap: 24px;
    grid-template-columns: 1fr 1fr;
  }

  ${mdStyle} {
    gap: 24px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`

export const PriceNewsTitle = styled.h2`
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  font-size: 20px;

  ${smStyle} {
    font-size: 24px;
  }
`

export const PriceNewsSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ArticleItemStyled = styled.li`
  list-style: none;
  width: 100%;
  height: max-content;
  border-radius: 8px;
  position: relative;
  z-index: 0;
  transform: scale(1);
  border: 1px solid var(--color-divider-2);
  transition: transform 0.3s ease-in-out; /* 设置过渡效果 */

  &:hover {
    transform: scale(1.02);
    box-shadow: 0px 7px 20px 0px #0d1f4212;
  }

  a {
    display: block;
  }

  .price-article-item--image {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
    aspect-ratio: 2/1;
  }
`

export const ArticleItemDescBox = styled.div`
  min-height: 48px;
  padding: 12px;

  ${smStyle} {
    padding: 16px 12px;
  }
`

export const ArticleItemDescStyled = styled.div`
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-height: 150%;
  font-size: 14px;
  font-weight: 400;

  ${smStyle} {
    font-size: 16px;
  }
`

export const FundraisingNewsItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: var(--color-card-3);
  border: 1px solid var(--color-divider-2);
  padding: 16px 12px;
  border-radius: 8px;
  overflow: hidden;
  box-sizing: border-box;
  height: max-content;
  cursor: pointer;

  .fundraising-bg {
    width: calc(100% + 24px) !important;
    margin: -16px -12px;
    height: calc((100% + 24px) * 9 / 16) !important;
    aspect-ratio: 16 / 9 !important;
    border-radius: 8px;
    object-fit: cover;
  }

  .fundraising-author {
    height: 48px;
  }
`
